"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toUnderscore = exports.toSnakeCase = exports.toFormUrlEncoded = exports.toCamelCase = void 0;
/**
 * Recursively transforms an object keys to camelcase.
 *
 * @param {object} object The object you want to transform to camelcase.
 */
const toCamelCase = object => {
  if (!object) {
    return {};
  }
  if (object instanceof Array) {
    return object.map(value => {
      let newValue = value;
      if (typeof value === 'object') {
        newValue = toCamelCase(value);
      }
      return newValue;
    });
  }
  const newObject = {};
  Object.keys(object).forEach(originalKey => {
    if (originalKey in object) {
      const tempNewKey = originalKey.replace(/(_\w)/g, match => match[1].toUpperCase());
      const newKey = `${tempNewKey[0].toLowerCase()}${tempNewKey.substring(1)}`;
      let value = object[originalKey];
      if (value instanceof Array || value instanceof Object && !(value instanceof Date)) {
        value = toCamelCase(value);
      }
      newObject[newKey] = value;
    }
  });
  return newObject;
};

/**
 * Recursively transforms an object keys from camel case to underscore format.
 *
 * @param {object} object The object you want to transform to underscore format.
 */
exports.toCamelCase = toCamelCase;
const toUnderscore = object => {
  if (!object) {
    return undefined;
  }
  if (object instanceof Array) {
    return object.map(value => {
      let newValue = value;
      if (typeof value === 'object') {
        newValue = toUnderscore(value);
      }
      return newValue;
    });
  }
  const newObject = {};
  Object.keys(object).forEach(originalKey => {
    if (originalKey in object) {
      const newKey = originalKey.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
      let value = object[originalKey];
      if (value instanceof Array || value instanceof Object && !(value instanceof Date)) {
        value = toUnderscore(value);
      }
      newObject[newKey] = value;
    }
  });
  return newObject;
};

/**
 * Recursively transforms an object keys to snakecase.
 *
 * @param {object} object The object you want to transform to snakecase.
 */
exports.toUnderscore = toUnderscore;
const toSnakeCase = object => {
  if (!object) {
    return {};
  }
  if (object instanceof Array) {
    return object.map(value => {
      let newValue = value;
      if (typeof value === 'object') {
        newValue = toSnakeCase(value);
      }
      return newValue;
    });
  }
  const newObject = {};
  Object.keys(object).forEach(originalKey => {
    if (originalKey in object) {
      const newKey = originalKey.replace(/[A-Z]/g, match => `_${match.toLowerCase()}`);
      let value = object[originalKey];
      if (value instanceof Array || value instanceof Object && !(value instanceof Date)) {
        value = toSnakeCase(value);
      }
      newObject[newKey] = value;
    }
  });
  return newObject;
};

/**
 * Transforms and object to a form encoded url string.
 *
 * @param {object} object The object you want to transform to an encoded url string.
 */
exports.toSnakeCase = toSnakeCase;
const toFormUrlEncoded = object => Object.keys(object).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
exports.toFormUrlEncoded = toFormUrlEncoded;